import { createReducer, on } from "@ngrx/store";
import { IVesselStop } from "../model/vessel-stop";
import { IQueryResult } from "@pmis3/data-access";
import { LoadVesselStops, LoadVesselStopsSuccess, LoadVesselStopsFail, LoadVesselStopsByDateRange } from "../action/vesselStop.action";
import { IDateTimeRange } from "@pmis3/core";

export enum VesselStopStateStatus {
  LOADING = "loading vessel stops",
  FAILED = "load vessel stops failed",
  PENDING = "load vessel stops pending",
  SUCCESS = "load vessel stops success"
}
export interface VesselStopState {
  vesselStops: IQueryResult<IVesselStop>;
  error?: string;
  status: VesselStopStateStatus;
  dateRange?: IDateTimeRange;
}

export const initialVesselStopState: VesselStopState = {
    vesselStops: { query: { pageIndex: 0, pageSize: 0 }, items: [], totalCount: 0 },
    status: VesselStopStateStatus.PENDING
}

export const vesselStopReducer = createReducer(
    initialVesselStopState,
    on(LoadVesselStops, (state) => ({...state, status: VesselStopStateStatus.LOADING})),
    on(LoadVesselStopsByDateRange, (state, action) => ({...state, dateRange: action.dateRange, status: VesselStopStateStatus.LOADING})),
    on(LoadVesselStopsSuccess, (state, {result: vesselStops }) => ({...state, vesselStops, dateRange: state.dateRange, status: VesselStopStateStatus.SUCCESS})),
    on(LoadVesselStopsFail, (state, { error }) => ({...state, error, status: VesselStopStateStatus.FAILED}))
)